import type { ComponentType } from 'react'

export interface Route {
  /** Percorso pubblico, senza slash finale (la home è '/') */
  path: string
  /** File HTML generato in dist/ */
  file: string
  /** Sorgente della pagina: serve a trovarne i chunk nel manifest di Vite (scripts/prerender.mjs) */
  source: string
  /** Ogni pagina è un chunk a parte: la home non scarica il codice del form (PrimeReact) */
  load: () => Promise<{ default: ComponentType }>
  /** Titolo della pagina; se manca si usa quello del sito */
  title?: string
  indexable: boolean
}

export const routes: Route[] = [
  {
    path: '/',
    file: 'index.html',
    source: 'src/pages/Home.tsx',
    load: () => import('@/pages/Home'),
    indexable: true,
  },
  {
    path: '/digitalizza-il-tuo-menu',
    file: 'digitalizza-il-tuo-menu.html',
    source: 'src/pages/OnboardingPage.tsx',
    load: () => import('@/pages/OnboardingPage'),
    title: 'Digitalizza il tuo menu',
    indexable: true,
  },
]

// Servita dal web server per qualsiasi URL inesistente (vedi nginx/default.conf)
export const notFoundRoute: Route = {
  path: '/404',
  file: '404.html',
  source: 'src/pages/NotFound.tsx',
  load: () => import('@/pages/NotFound'),
  title: 'Pagina non trovata',
  indexable: false,
}

/** '/x/', '/x.html' e '/index.html' diventano '/x' e '/' */
export function normalizePath(pathname: string): string {
  const path = pathname
    .replace(/\/index\.html$/, '/')
    .replace(/\.html$/, '')
    .replace(/(.)\/+$/, '$1')
  return path || '/'
}

export function resolveRoute(pathname: string): Route {
  return routes.find((route) => route.path === pathname) ?? notFoundRoute
}
